// extracted by mini-css-extract-plugin
export default {"box":"MainCategories_box__r5xs1"};